export default function NotFound() {
  return (
    <div>
      <h1>Not found</h1>
    </div>
  );
}
